/* ============================================================
   INVINCE — theme.js
   Cart drawer (AJAX), mobile menu, countdown, newsletter, PDP.
   Native Shopify cart via /cart/*.js + Section Rendering API.
   ============================================================ */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function rootUrl(path) {
    return (routes.replace(/\/$/, '') + '/' + path.replace(/^\//, ''));
  }

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: function () { return document.getElementById('CartDrawer'); },
    backdrop: function () { return document.getElementById('CartBackdrop'); },

    open: function () {
      var d = this.drawer(), b = this.backdrop();
      if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      if (b) b.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var d = this.drawer(), b = this.backdrop();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      if (b) b.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    updateCounts: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
      document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
        el.classList.toggle('is-filled', count > 0);
      });
    },

    // Re-render the drawer section HTML and swap it in.
    refresh: function () {
      return fetch(rootUrl('?sections=cart-drawer'))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartDrawerInner');
          var current = document.getElementById('CartDrawerInner');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var countNode = doc.querySelector('[data-cart-total-count]');
          if (countNode) Cart.updateCounts(countNode.getAttribute('data-cart-total-count'));
          Cart.bindLineItems();
        });
    },

    add: function (formData, button) {
      var original = button ? button.getAttribute('data-add-label') : '';
      if (button) { button.setAttribute('data-original', button.innerHTML); }
      return fetch(rootUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () { return Cart.refresh(); })
        .then(function () {
          if (button) {
            button.classList.add('is-added');
            button.innerHTML = (window.InvinceStrings && window.InvinceStrings.added) || 'ADDED ✓';
            setTimeout(function () {
              button.classList.remove('is-added');
              if (button.getAttribute('data-original')) button.innerHTML = button.getAttribute('data-original');
              Cart.open();
            }, 650);
          } else {
            Cart.open();
          }
        })
        .catch(function (err) {
          console.warn('[Invince] add to cart failed', err);
          if (button && button.getAttribute('data-original')) button.innerHTML = button.getAttribute('data-original');
        });
    },

    change: function (line, quantity) {
      return fetch(rootUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); });
    },

    bindLineItems: function () {
      var inner = document.getElementById('CartDrawerInner');
      if (!inner) return;
      inner.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = parseInt(btn.getAttribute('data-line'), 10);
          var qty = parseInt(btn.getAttribute('data-qty-change'), 10);
          Cart.change(line, qty);
        });
      });
      inner.querySelectorAll('[data-remove-line]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          Cart.change(parseInt(btn.getAttribute('data-remove-line'), 10), 0);
        });
      });
    }
  };
  window.InvinceCart = Cart;

  /* ---------- Mobile menu ---------- */
  var Menu = {
    el: function () { return document.getElementById('MobileMenu'); },
    open: function () { var m = this.el(); if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; } },
    close: function () { var m = this.el(); if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; } }
  };
  window.InvinceMenu = Menu;

  /* ---------- Zoom lightbox ---------- */
  function openZoom(src) {
    var box = document.getElementById('ZoomLightbox');
    if (!box) return;
    var img = box.querySelector('[data-zoom-img]');
    if (img) img.style.backgroundImage = 'url("' + src + '")';
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeZoom() {
    var box = document.getElementById('ZoomLightbox');
    if (!box) return;
    box.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.InvinceZoom = { open: openZoom, close: closeZoom };

  /* ---------- Countdown ---------- */
  function initCountdown() {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var dd = Math.floor(diff / 86400000); diff -= dd * 86400000;
      var hh = Math.floor(diff / 3600000); diff -= hh * 3600000;
      var mm = Math.floor(diff / 60000); diff -= mm * 60000;
      var ss = Math.floor(diff / 1000);
      var set = function (k, v) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = pad(v); };
      set('days', dd); set('hours', hh); set('minutes', mm); set('seconds', ss);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Global wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); return; }
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); Menu.open(); return; }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); Menu.close(); return; }
    var z = e.target.closest('[data-zoom-open]');
    if (z) { e.preventDefault(); openZoom(z.getAttribute('data-zoom-open')); return; }
    if (e.target.closest('[data-zoom-close]')) { e.preventDefault(); closeZoom(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { Cart.close(); Menu.close(); closeZoom(); }
  });

  // Intercept product add-to-cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    Cart.add(new FormData(form), btn);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    Cart.bindLineItems();
  });
})();
